import { Routes, Route, Navigate } from 'react-router-dom';
import BackgroundBlobs from './components/ui/BackgroundBlobs';
import HomeScreen from './screens/HomeScreen';
import QuizScreen from './screens/QuizScreen';
import ResultScreen from './screens/ResultScreen';
import LeaderboardScreen from './screens/LeaderboardScreen';
import TitleHallScreen from './screens/TitleHallScreen';
import AdminScreen from './screens/AdminScreen';
import NicknameModal from './components/ui/NicknameModal';
import StreakToast from './components/ui/StreakToast';
import ConfettiLayer from './components/ui/ConfettiLayer';

export default function App() {
  return (
    <>
      <BackgroundBlobs />
      <div className="app">
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/quiz" element={<QuizScreen />} />
          <Route path="/result" element={<ResultScreen />} />
          <Route path="/leaderboard" element={<LeaderboardScreen />} />
          <Route path="/titles" element={<TitleHallScreen />} />
          <Route path="/admin" element={<AdminScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <NicknameModal />
      <StreakToast />
      <ConfettiLayer />
    </>
  );
}
